import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  clean?: (_: string) => string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, clean, ...props }, ref) => {
    return (
      <>
        <input
          hidden
          type="text"
          value={clean && props.value ? clean(props.value.toString()) : props.value}
          name={props.name}
        />
        <input
          id={props.name}
          type={type}
          className={cn(
            "flex w-full rounded-md border bg-background p-2 md:text-base text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 border-[#CCC2BF] focus-visible:border-[#232329]",
            "h-[58px]",
            className,
          )}
          ref={ref}
          {...{ ...props, name: undefined }}
          readOnly={props.readOnly}
        />
      </>
    );
  },
);
Input.displayName = "Input";

export { Input };
